import APIClient from '@/shared/http/clients/api'

const resourceName = 'QMATemplatePerguntasVerificacao'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon
const GetPreRequisitos = (id, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetPreRequisitos/${id}`, data, config)

const qmaTemplateQuestion = {
  GetPreRequisitos
}

export default qmaTemplateQuestion



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/qmaTemplateQuestion.js